"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolRenewalFormName = exports.SchoolLeadsFormName = void 0;
exports.SchoolLeadsFormName = 'schoolLeads-v1';
exports.SchoolRenewalFormName = 'schoolRenewal-v1';
//# sourceMappingURL=formNames.js.map